import { render, staticRenderFns } from "./Acquisti.vue?vue&type=template&id=3bf674be"
import script from "./Acquisti.vue?vue&type=script&lang=js"
export * from "./Acquisti.vue?vue&type=script&lang=js"
import style0 from "./Acquisti.vue?vue&type=style&index=0&id=3bf674be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports